import { StringKeys } from 'cng-common/models/utils'
import { Crud } from 'core/types/Crud'
import Logger from 'core/utils/Logger'

import { getDropdownItemByKeyField } from './getDropdownItemByKeyField'

interface IParams<T> {
  source: Crud<T, string | number>
  keyField: StringKeys<T>
  caption: StringKeys<T>
  value: string
}

export async function getDropdownValueByKeyField<T>(params: IParams<T>): Promise<string> {
  const item = await getDropdownItemByKeyField<T>(params)

  if (item) {
    try {
      return String(item[params.caption])
    } catch (error) {
      Logger.error('Error in getDropdownValueByKeyField', params, error)
      return ''
    }
  }

  return ''
}
